// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__3d6U3","modalForm":"UpgradeEpcsModal_modalForm__38sYO","modalFooter":"UpgradeEpcsModal_modalFooter__34LQc"};